import db from "../db/database";

class FormaDePagoService {
    async getAll() {
        return await db.formasPago.toArray();
    }

    // Alias de getAll() para mantener compatibilidad con componentes existentes
    async getAllFormasDePago() {
        return await this.getAll();
    }

    async getById(id) {
        return await db.formasPago.get(id);
    }

    async getByCode(code) {
        return await db.formasPago.where("Code").equals(code).first();
    }
}

const formaDePagoService = new FormaDePagoService();
export default formaDePagoService; 